import React from 'react';

const PrivacyPolicy = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <div className="modal-body">
          <div className="modal-header-logo">
            <img src="/LandingPageAssets/Logos/jk-logo-full-300.png" alt="J&K Realty" className="privacy-logo" />
          </div>
          <h2>Política de Privacidad</h2>
          <p className="last-updated">Última actualización: Enero 2025</p>

          <section>
            <h3>1. Información General</h3>
            <p>
              J&K Realty (en adelante "la Empresa")
              se compromete a proteger la privacidad y seguridad de la información personal de sus
              clientes y usuarios de conformidad con la Ley Orgánica de Protección de Datos Personales
              del Ecuador y demás normativa aplicable.
            </p>
          </section>

          <section>
            <h3>2. Responsable del Tratamiento de Datos</h3>
            <p>
              <strong>Razón Social:</strong> J&K Realty<br />
              <strong>Teléfono:</strong> +593 99 541 0584<br />
              <strong>Email:</strong> karen@jkrealty.ec<br />
              <strong>Instagram:</strong> @jk_realty_uio
            </p>
          </section>

          <section>
            <h3>3. Información que Recopilamos</h3>
            <p>Podemos recopilar los siguientes tipos de información personal:</p>
            <ul>
              <li>Nombre completo y datos de identificación</li>
              <li>Información de contacto (teléfono, correo electrónico, dirección)</li>
              <li>Información sobre preferencias de propiedades</li>
              <li>Información financiera necesaria para transacciones inmobiliarias</li>
              <li>Historial de comunicaciones con nuestra empresa</li>
              <li>Información proporcionada voluntariamente a través de WhatsApp, Instagram o llamadas telefónicas</li>
            </ul>
          </section>

          <section>
            <h3>4. Uso de la Información</h3>
            <p>Utilizamos su información personal para:</p>
            <ul>
              <li>Proporcionar servicios inmobiliarios de compra, venta y consultoría</li>
              <li>Comunicarnos con usted sobre propiedades disponibles</li>
              <li>Procesar transacciones inmobiliarias</li>
              <li>Enviar información sobre nuestros servicios (con su consentimiento previo)</li>
              <li>Cumplir con obligaciones legales y regulatorias del sector inmobiliario ecuatoriano</li>
              <li>Mejorar nuestros servicios y experiencia del cliente</li>
            </ul>
          </section>

          <section>
            <h3>5. Base Legal para el Tratamiento</h3>
            <p>
              El tratamiento de sus datos personales se realiza bajo las siguientes bases legales:
            </p>
            <ul>
              <li>Consentimiento expreso del titular de los datos</li>
              <li>Ejecución de un contrato de servicios inmobiliarios</li>
              <li>Cumplimiento de obligaciones legales aplicables</li>
              <li>Interés legítimo de la Empresa en el desarrollo de su actividad profesional</li>
            </ul>
          </section>

          <section>
            <h3>6. Compartir Información</h3>
            <p>
              Su información personal puede ser compartida únicamente con:
            </p>
            <ul>
              <li>Entidades financieras para procesar transacciones</li>
              <li>Notarías y registros de la propiedad según sea necesario</li>
              <li>Autoridades gubernamentales cuando sea requerido por ley</li>
              <li>Otros profesionales inmobiliarios únicamente con su autorización expresa</li>
            </ul>
            <p>
              <strong>No vendemos, alquilamos ni compartimos su información personal con terceros
              para fines de marketing sin su consentimiento explícito.</strong>
            </p>
          </section>

          <section>
            <h3>7. Seguridad de los Datos</h3>
            <p>
              Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger
              su información personal contra acceso no autorizado, pérdida, alteración o divulgación.
              Sin embargo, ningún método de transmisión por Internet es 100% seguro.
            </p>
          </section>

          <section>
            <h3>8. Sus Derechos</h3>
            <p>
              De conformidad con la legislación ecuatoriana, usted tiene los siguientes derechos:
            </p>
            <ul>
              <li><strong>Acceso:</strong> Conocer qué datos personales tenemos sobre usted</li>
              <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos o incompletos</li>
              <li><strong>Eliminación:</strong> Solicitar la eliminación de sus datos personales</li>
              <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos personales</li>
              <li><strong>Portabilidad:</strong> Solicitar una copia de sus datos en formato estructurado</li>
              <li><strong>Revocación del consentimiento:</strong> Retirar su consentimiento en cualquier momento</li>
            </ul>
            <p>
              Para ejercer estos derechos, puede contactarnos a través de:
            </p>
            <ul>
              <li>Teléfono/WhatsApp: +593 99 541 0584</li>
              <li>Email: karen@jkrealty.ec</li>
              <li>Instagram: @jk_realty_uio</li>
            </ul>
          </section>

          <section>
            <h3>9. Retención de Datos</h3>
            <p>
              Conservaremos su información personal durante el tiempo necesario para cumplir con los
              fines para los que fue recopilada, incluyendo requisitos legales, contables y de reporte,
              o hasta que solicite su eliminación, lo que ocurra primero.
            </p>
          </section>

          <section>
            <h3>10. Comunicaciones por WhatsApp e Instagram</h3>
            <p>
              Al comunicarse con nosotros a través de WhatsApp o Instagram, usted acepta que
              podemos utilizar estos canales para responder a sus consultas y proporcionarle
              información sobre propiedades y servicios. Puede optar por no recibir estas
              comunicaciones en cualquier momento.
            </p>
          </section>

          <section>
            <h3>11. Cookies y Tecnologías Similares</h3>
            <p>
              Este sitio web puede utilizar cookies para mejorar la experiencia del usuario.
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo.
              Puede configurar su navegador para rechazar todas las cookies o para indicar
              cuándo se está enviando una cookie.
            </p>
          </section>

          <section>
            <h3>12. Menores de Edad</h3>
            <p>
              Nuestros servicios no están dirigidos a menores de 18 años. No recopilamos
              intencionalmente información personal de menores sin el consentimiento de
              sus padres o tutores legales.
            </p>
          </section>

          <section>
            <h3>13. Cambios a esta Política</h3>
            <p>
              Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier
              momento. Los cambios significativos serán notificados a través de nuestros
              canales de comunicación habituales. Le recomendamos revisar periódicamente
              esta política.
            </p>
          </section>

          <section>
            <h3>14. Legislación Aplicable</h3>
            <p>
              Esta Política de Privacidad se rige por las leyes de la República del Ecuador,
              incluyendo pero no limitándose a:
            </p>
            <ul>
              <li>Ley Orgánica de Protección de Datos Personales</li>
              <li>Constitución de la República del Ecuador</li>
              <li>Normativa aplicable al sector inmobiliario ecuatoriano</li>
            </ul>
          </section>

          <section>
            <h3>15. Contacto</h3>
            <p>
              Si tiene preguntas, comentarios o inquietudes sobre esta Política de Privacidad
              o sobre cómo manejamos su información personal, contáctenos:
            </p>
            <p>
              <strong>J&K Realty</strong><br />
              Teléfono/WhatsApp: +593 99 541 0584<br />
              Email: karen@jkrealty.ec<br />
              Instagram: @jk_realty_uio<br />
              Ubicación: Quito y Valles, Ecuador
            </p>
          </section>

          <div className="policy-footer">
            <p>
              Al utilizar nuestros servicios, usted reconoce que ha leído y comprendido esta
              Política de Privacidad y acepta el tratamiento de sus datos personales según
              lo descrito en la misma.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
